import React from 'react'
import { Box, Container, Typography } from '@mui/material'
import { formlessColors } from '@zuto/theme/src/mui/Colors'

type Props = {
  source: string
}

const LandingFooter: React.FC<Props> = ({source}) => {
  const footerText = source === "clearscore"
            ? "Zuto is a credit broker, not a lender. We work with trusted partners including ClearScore."
            : "Zuto is a credit broker, not a lender."
  return (
    <Box
      sx={{
        borderTop: 1,
        borderColor: formlessColors.borderSubtle,
        marginTop: 9,
        paddingTop: 9,
        paddingBottom: 9,
        textAlign: 'center'
      }}
    >
      <Container sx={{ paddingLeft: 5, paddingRight: 5 }}>
        <Typography
          sx={{
            marginBottom: 1,
            color: formlessColors.textMuted
          }}
          variant="bodySmall"
          component="p"
        >
          © {new Date().getFullYear()} Zuto Limited. All rights reserved.
        </Typography>

        <Typography
          sx={{ color: formlessColors.textMuted }}
          variant="bodySmall"
          component="p"
        >
          {footerText} 
        </Typography>
      </Container>
    </Box>
  )
}

export default LandingFooter
